import React, { useState } from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
} from "../../../styles";
import { useTranslation } from "react-i18next";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ReorderableSpaces from "./ReorderableSpaces";
import SpacePicker from "../../../../../../../components/ui/space-picker/SpacePicker";
import { useSpacesStore } from "../../../../../../../stores/use-space-store";
import { useSpaces } from "../../../../../../../features/spaces/useSpaces";

function Manual() {
  const { t } = useTranslation();
  const [pickerKey, setPickerKey] = useState(crypto.randomUUID());

  const { data, selectedTab, updateConfigTab } = useSpacesStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
    updateConfigTab: state.updateConfigTab,
  }));

  const onSelect = ({ selectedSpace }) => {
    if (
      !selectedSpace ||
      !!data.config.tabs[selectedTab].manuallyPicked.find(
        (space) => String(selectedSpace) === String(space.spacekey)
      )
    ) {
      return;
    }

    const currentLastPicked =
      data.config.tabs[selectedTab].manuallyPicked.length > 0
        ? data.config.tabs[selectedTab].manuallyPicked[
            data.config.tabs[selectedTab].manuallyPicked.length - 1
          ]
        : null;

    const position = currentLastPicked ? currentLastPicked.position + 1 : 0;
    updateConfigTab({
      value: {
        manuallyPicked: [
          ...data.config.tabs[selectedTab].manuallyPicked,
          {
            id: crypto.randomUUID(),
            position,
            spaceKey: selectedSpace.spaceKey,
          },
        ],
      },
    });

    setPickerKey(Math.random().toString(36).substring(7));
  };

  const spaceQueries = useSpaces(
    data.config?.tabs[selectedTab]?.manuallyPicked || []
  );

  const initialSpaces =
    data.config?.tabs[selectedTab]?.manuallyPicked?.map(
      (space) => space.spaceKey
    ) || [];

  const removeSpace = (id) => {
    const newManuallyPicked = data.config.tabs[
      selectedTab
    ].manuallyPicked.filter((space) => space.id !== id);
    updateConfigTab({
      value: {
        manuallyPicked: newManuallyPicked,
      },
    });

    setPickerKey(crypto.randomUUID());
  };

  const resetOrder = (list) => {
    const resetList = list.map((c, index) => {
      const slide = c;
      slide.order = index + 1;
      return slide;
    });
    return resetList;
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return resetOrder(result);
  };

  const reorderPanels = (sourceId, targetId) => {
    if (sourceId === targetId) {
      return;
    }
    const copyOfSpaces = [...spaceQueries.map(({ data }) => data)];
    const sourceIndex = sourceId;
    const targetIndex = targetId;
    const items = reorder(copyOfSpaces, sourceIndex, targetIndex);

    updateConfigTab({
      value: {
        manuallyPicked: items,
      },
    });
  };

  return (
    <>
      <>
        <SettingsOptionContainer>
          <OptionContainer direction="column">
            <OptionLabel>{t("spaces")}</OptionLabel>
            <OptionContent full>
              <SpacePicker
                key={initialSpaces.join("-")}
                initialSpaces={initialSpaces}
                onUpdate={(selectedSpace) => onSelect({ selectedSpace })}
                isSpaceManual
              />
            </OptionContent>
          </OptionContainer>

          <DndProvider backend={HTML5Backend}>
            <OptionContainer direction="column">
              {spaceQueries.map(({ data }, _idx) => (
                <ReorderableSpaces
                  space={data}
                  index={_idx}
                  reorderPanels={reorderPanels}
                  removeSpace={removeSpace}
                />
              ))}
            </OptionContainer>
          </DndProvider>
        </SettingsOptionContainer>
      </>
    </>
  );
}

export default Manual;
